import * as THREE from 'three'
import { GeckoComponentRect, GeckoCone, GeckoMeasurementUnit } from 'types'
// --------------------------- Cone ------------------------------
/**
 * Translates 2D coordinates on a cone to a 3D camera orientation that will face those coordinates
 * @param componentX x position on component, assumed to be in the same x units as the componentBounds
 * @param componentY y position on component, assumed to be in the same y units as the componentBounds
 * @param distToComponent distance to surface
 * @param cone
 * @param componentBounds
 * @returns
 */
export const getConeCameraPosition = (
  componentX: number,
  componentY: number,
  distToComponent: number,
  cone: GeckoCone,
  componentBounds: GeckoComponentRect
) => {
  const relX = componentX - componentBounds.start.x.num
  const relY = componentY - componentBounds.start.y.num

  const angle = ((relX * 7 * Math.PI) / 180) % (2 * Math.PI) // multiply by 7 to make x rotation faster
  const radiusDelta = cone.outerRadius.num - cone.innerRadius.num
  const coneRelY = radiusDelta - relY
  const coneComponentY = coneRelY + cone.innerRadius.num
  const yDiff = (coneRelY * cone.coneHeight.num) / radiusDelta
  const y = cone.coneHeight.num - yDiff
  const position = new THREE.Vector3(
    (coneComponentY + 0) * -Math.cos(angle),
    y,
    (coneComponentY + 0) * Math.sin(angle)
  )
  // calculate camera rotation
  const coneAngleRadians = cone.angle.toNumber(GeckoMeasurementUnit.Radians)
  const cameraYRotation = angle - Math.PI / 2
  const cameraMatrixX = new THREE.Matrix4().makeRotationX(
    coneAngleRadians - Math.PI / 2
  )
  const cameraMatrixY = new THREE.Matrix4().makeRotationY(cameraYRotation)
  const cameraMatrix = new THREE.Matrix4()
    .multiply(cameraMatrixY)
    .multiply(cameraMatrixX)
  const quaternion = new THREE.Quaternion().setFromRotationMatrix(cameraMatrix)
  const euler = new THREE.Euler().setFromQuaternion(quaternion)

  // get normal and offset position by distToComponent
  const normal = new THREE.Vector3(
    0,
    Math.cos(coneAngleRadians),
    Math.sin(coneAngleRadians)
  )

  normal.applyEuler(new THREE.Euler(0, cameraYRotation, 0))
  normal.multiplyScalar(distToComponent)
  position.add(normal)
  return {
    position: [position.x, position.y, position.z] as [number, number, number],
    rotation: [euler.x, euler.y, euler.z] as [number, number, number],
  }
}
